export default __webpack_public_path__ + "static/media/login-dark.b4685ad3.svg";